
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import {
		productMaterialList,
		productMaterialDelete,
		productMaterialSave
	} from '@/api/material';
	import PageFooter from '@/components/page-footer.vue';
	import Message from '@/components/message.vue';
	import {imgHost} from '@/utils/config'

	@Component({
		name: 'product-material',
		components: {
			PageFooter,
			Message
		}
	})
	export default class ProductMaterial extends Vue {
		private imgHost = imgHost;
		private id = this.$route.query.id;
		private name = this.$route.query.name;
		private imgUrl = this.$route.query.img;
		private list: any = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private keywords = '';
		private deleteId = ''
		
		private showDialog = false;

		private mounted() {
			// console.log(this.imgUrl)
			this.getList();
		}

		private changeCurrent(e: any) {
			this.pageNo = e;
			this.getList();
		}

		/**
		 * 搜索
		 */
		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		/**
		 * 清空搜索内容
		 */
		private clearSearch() {
			this.keywords = '';
			this.pageNo = 1;
			this.getList();
		}

		private async getList() {
			try {
				const res: any = await productMaterialList({
					ProductId: this.id,
					Skip: (this.pageNo - 1) * this.pageSize,
					Take: this.pageSize,
					Keywords: this.keywords
				})
				this.total = res.Result.Total;
				this.list = res.Result.Results;
				// console.log(this.list)
			} catch (e) {
				console.log(e);
			}
		}
		
		/**
		 * 添加编辑
		 */
		toDetail(id){
			this.$router.push({
				name: 'product-material-detail',
				query: {
					id: id,
					productId: this.id
				}
			})
		}
		
		/**
		 * 删除
		 */
		private toDelete(id:any){
			this.showDialog = true;
			this.deleteId = id;
		}
		private async confirmDelete(){
			try{
				const res = await productMaterialDelete({
					Id: this.deleteId
				});
				this.$message({
					type: 'success',
					message: '删除成功'
				})
				this.showDialog = false;
				this.getList();
			}catch(err){
				console.log(err)
			}
		}
	}
